export default "__VITE_ASSET__b18kp99j__"